import {Button} from '@/components';
import {Input} from '@/components/common/Input';

import type {SetPasswordFormProps} from './useSetPassword';

const SetPasswordForm = ({
  isLoading,
  handleSubmit,
  handleChange,
}: SetPasswordFormProps) => (
  <div className="min-h-screen w-full dark:bg-dark-background flex justify-center items-center px-4">
    <div className="w-full sm:w-4/5 md:w-3/5 lg:w-2/5 flex flex-col justify-center items-center border rounded-md py-7 px-4 dark:border-dark-navBorder">
      <h1 className="text-center text-gray-700 dark:text-gray-100 font-semibold text-xl">
        Set a new password
      </h1>

      <div className="flex flex-col justify-center items-center w-full my-5 p-2 sm:p-5">
        <form
          className="w-full sm:w-3/5 flex flex-col space-y-10"
          onSubmit={handleSubmit}
          data-cy="admin-set-password-form"
        >
          <Input
            onChange={handleChange}
            label="New password"
            type="password"
            name="password"
            autoComplete="new-password"
            required
            className="w-full dark:text-gray-200"
          />

          <Input
            onChange={handleChange}
            label="Confirm new password"
            type="password"
            name="confirmPassword"
            autoComplete="new-password"
            required
            className="w-full dark:text-gray-200"
          />

          <Button
            variant="solid"
            colorScheme="cyan"
            type="submit"
            isLoading={isLoading}
            loadingText="Saving..."
          >
            Save password
          </Button>
        </form>
      </div>
    </div>
  </div>
);

export default SetPasswordForm;
